export default {
  // 页面标题
  title: '爆款创意',
  
  // 设置弹窗
  setup: {
    title: '选择品牌以生成爆款创意',
    placeholder: '请输入网址',
    addButton: '添加',
    errorMessage: '请输入正确的网址'
  },
  
  // 标签相关
  tags: {
    remove: '移除',
    add: '添加'
  },
  
  // 内容相关
  content: {
    views: '播放量',
    platform: '平台',
    user: '用户'
  },
  
  // 加载状态
  loading: {
    title: '加载中…',
    description: '正在获取爆款创意，请稍候'
  },
  
  // 错误状态
  error: {
    title: '发生错误',
    description: '爆款创意加载失败'
  },
  
  // 空状态
  empty: {
    title: '未找到爆款创意',
    description: '试着添加一些品牌以生成爆款创意'
  },
  
  // 侧边栏
  sidebar: {
    startCampaign: '新建活动',
    startTask: '新建任务',
    viralIdeas: '爆款创意',
    headsDna: 'Aha DNA'
  }
};
